import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: () => import('../views/InventoryView.vue'),
    },
    {
      path: '/add',
      name: 'add',
      component: () => import('../views/AddOrder.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('../views/ActiveOrders.vue'),
    },
    {
      path: '/orders-history',
      name: 'orders-history',
      component: () => import('../views/OrdersHistoryView.vue'),
    },
    {
      path: '/price-list',
      name: 'price-list',
      component: () => import('../views/PriceListView.vue'),
    },
    {
      path: '/stock-take',
      name: 'stock-take',
      component: () => import('../views/StockTakeView.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
    },
  ],
})

export default router
